<!-- PASSES -->
<template>
    <v-row no-gutters class="fill-height">
        <!-- // * LEFT PANEL -->
        <v-col :cols="GET_panelLayout.leftPanel">
            <v-row class="px-2 mt-2 pa-0" dense>
                <!-- // * DESCRIPTION -->
                <v-col cols="6">
                    <v-row no-gutters class="">
                        <v-col class="px-2" cols="12" xs="6" sm="6" md="12">
                            <app-text category="content-title"
                                >{{ $t(`${langPath}.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text
                            >
                            <app-text
                                class="help-text"
                                v-if="GET_help && GET_currentUser.userType === 'CONTRACTOR'"
                                v-html="$t(`${langPath}.text.contractor`)"
                            ></app-text>
                            <app-text
                                class="help-text"
                                v-if="GET_help && GET_currentUser.userType !== 'CONTRACTOR'"
                                v-html="$t(`${langPath}.text.default`)"
                            ></app-text>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * FILTERS -->
                <v-col cols="6" class="px-2">
                    <v-row dense class="d-flex justify-start">
                        <v-col
                            cols="12"
                            xs="12"
                            sm="12"
                            md="6"
                            class=""
                            v-if="$vuetify.breakpoint.lgAndUp && ['VM', 'VA', 'CM', 'CA', 'SM', 'SA', 'DA'].includes(GET_currentUser.userLevel)"
                        >
                            <v-select
                                :menu-props="{ top: false, offsetY: true }"
                                :attach="true"
                                background-color="white"
                                v-model="filter.site"
                                :items="sites"
                                item-text="siteName"
                                item-value="siteId"
                                filled
                                dense
                                clearable
                                :label="$t(`filters.site`)"
                                hide-details
                            >
                                <template v-slot:item="data">{{ data.item.siteName }}</template>
                                <template v-slot:selection="data">{{ data.item.siteName }}</template>
                            </v-select>
                        </v-col>
                        <v-col
                            cols="12"
                            xs="12"
                            sm="12"
                            md="6"
                            class=""
                            v-if="$vuetify.breakpoint.lgAndUp && ['VM', 'VA', 'CM', 'CA', 'SM', 'SA', 'DA'].includes(GET_currentUser.userLevel)"
                        >
                            <v-autocomplete
                                :menu-props="{ top: false, offsetY: true }"
                                :attach="true"
                                color="black"
                                label="User"
                                v-model="filter.user"
                                :items="users"
                                item-text="userName"
                                item-value="id"
                                return-object
                                filled
                                hide-details="auto"
                                required
                                background-color="white"
                                dense
                                clearable
                            >
                                <template v-slot:item="data">
                                    {{ data.item.userName }}
                                </template>
                                <template v-slot:selection="data">
                                    {{ data.item.userName }}
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col
                            cols="12"
                            xs="12"
                            sm="12"
                            md="6"
                            class="d-flex align-center"
                            v-if="$vuetify.breakpoint.lgAndUp && ['VM', 'VA', 'CM', 'CA', 'SM', 'SA', 'DA'].includes(GET_currentUser.userLevel)"
                        >
                            <v-text-field
                                clearable
                                @click="MIX_datePicker(true, 'SWAPPFromDate')"
                                append-icon="mdi-calendar"
                                label="SWAPP From"
                                v-model="filter.formattedSWAPPFromDate"
                                filled
                                hide-details="auto"
                                background-color="white"
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            xs="12"
                            sm="12"
                            md="6"
                            class="d-flex align-center"
                            v-if="$vuetify.breakpoint.lgAndUp && ['VM', 'VA', 'CM', 'CA', 'SM', 'SA', 'DA'].includes(GET_currentUser.userLevel)"
                        >
                            <v-text-field
                                clearable
                                @click="MIX_datePicker(true, 'SWAPPToDate')"
                                append-icon="mdi-calendar"
                                label="SWAPP To"
                                v-model="filter.formattedSWAPPToDate"
                                filled
                                hide-details="auto"
                                background-color="white"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>

                <!-- // * STATUS AND BUTTONS -->
                <v-col cols="12" class="pl-2 pr-0 d-flex align-center">
                    <!-- // * SHOW DELETED -->
                    <div v-if="['DA'].includes(GET_currentUser.userLevel)">
                        <div class="d-flex" v-if="$vuetify.breakpoint.mdAndUp">
                            <v-icon class="ml-4 purple--text text-h4">icons8-trash</v-icon>
                            <v-switch @change="getTableData()" v-model="showDeleted" class="ml-1 purple--text" color="purple" inset></v-switch>
                        </div>
                    </div>
                    <!-- // * STATUS FILTER -->
                    <div>
                        <div class="font-weight-bold caption pb-1 grey--text">SWAPP Status</div>
                        <v-btn-toggle v-model="filter.status" multiple color="white" active-class="white" background-color="lightgrey" dense>
                            <v-btn :value="1">
                                <v-icon class="success--text icons8-filled-circle"></v-icon>
                                <span class="success--text caption hidden-sm-and-down">IN</span>
                            </v-btn>
                            <v-btn :value="0">
                                <v-icon class="lightgrey--text icons8-filled-circle"></v-icon>
                                <span class="darkgrey--text caption hidden-sm-and-down">OUT</span>
                            </v-btn>
                        </v-btn-toggle>
                    </div>

                    <v-spacer></v-spacer>
                    <!-- // * BUTTONS -->
                    <div v-if="['SA', 'DA'].includes(GET_currentUser.userLevel)" class="d-flex align-center pr-1">
                        <div v-if="$vuetify.breakpoint.mdAndUp && GET_panelLayout.leftPanel === 12">
                            <appbutton
                                :label="$t(`buttons.export`)"
                                icon="icons8-export-csv"
                                type="secondary"
                                iconclass="white--text"
                                labelclass="white--text"
                                showlabel="2xlOnly"
                                @click.native="exportCSV()"
                            />
                        </div>
                    </div>
                </v-col>

                <!-- // * TABLE -->
                <v-col class="mt-2 px-2 tabledata" v-if="$vuetify.breakpoint.mdAndUp" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-data-table
                        :headers="filteredHeaders"
                        :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                        :items="computedTableData"
                        item-key="id"
                        class="elevation-0"
                        :search="search"
                        :options.sync="datatableOptions"
                    >
                        <template v-slot:[`item.swappStatus`]="{ item }">
                            <v-chip class="success" small v-if="item.swappStatus === 1 || item.swappStatus === '1'">IN</v-chip>
                            <v-chip class="lightgrey" small v-else>OUT</v-chip>
                        </template>
                        <template v-slot:[`item.createdDateTime`]="{ item }">
                            <span>{{ MIX_formatDateTime(item.createdDateTime, 'x', 'DD-MMM-YY HH:mm') }}</span>
                        </template>
                        <template v-slot:[`item.swappMethod`]="{ item }">
                            <span>{{ MIX_capitalizeText(item.swappMethod) }}</span>
                        </template>
                        <!-- // ACTION -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn @click="openItem(item.id, 'View', false)" depressed class="black--text white"
                                >Open<v-icon>mdi-chevron-right</v-icon></v-btn
                            >
                        </template>
                        <!-- // CREATED USER DATA -->
                        <template v-slot:[`item.createdUserData`]="{ item }">
                            <div
                                v-if="item.createdUserData !== '' && item.createdUserData !== undefined && item.createdUserData !== null"
                                @click="MIX_popupUser(item.createdUserData.userId)"
                                class="pointer noselect fixedcolumn"
                            >
                                <v-icon>icons8-identification-documents</v-icon>
                                {{ item.createdUserData.userName }}
                            </div>
                        </template>
                        <!-- // MODIFIED USER DATA -->
                        <template v-slot:[`item.modifiedUserData`]="{ item }">
                            <div
                                v-if="item.modifiedUserData !== '' && item.modifiedUserData !== undefined && item.modifiedUserData !== null"
                                @click="MIX_popupUser(item.modifiedUserData.userId)"
                                class="pointer noselect fixedcolumn"
                            >
                                <v-icon>icons8-identification-documents</v-icon>
                                {{ item.createdUserData.userName }}
                            </div>
                        </template>
                        <!-- // DELETE USER DATA -->
                        <template v-slot:[`item.deleteUserData`]="{ item }">
                            <div
                                v-if="item.deleteUserData !== '' && item.deleteUserData !== undefined && item.deleteUserData !== null"
                                @click="MIX_popupUser(item.deleteUserData.userId)"
                                class="pointer noselect fixedcolumn"
                            >
                                <v-icon>icons8-identification-documents</v-icon>
                                {{ item.deleteUserData.userName }}
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
                <!-- // * MOBILE CARDS / Instead of Table -->
                <v-col class="px-2 tabledata" v-if="$vuetify.breakpoint.smAndDown" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-row no-gutters>
                        <v-col
                            cols="12"
                            xs="12"
                            class="my-1 pa-1 white tablecard"
                            v-for="item in computedTableData"
                            :key="item.id"
                            @click="openItem(item.id, 'View', false)"
                        >
                            <v-row class="d-flex align-center justify-center pa-3 fill-height" no-gutters>
                                <v-col cols="2" class="">
                                    <v-icon
                                        v-if="item.passStatus === 'APPROVED'"
                                        :style="{ 'background-image': 'url(' + require('@/assets/circle.svg') + ')' }"
                                        class="iconbackground display-1 success--text icons8-checkmark-yes"
                                    ></v-icon>
                                    <v-icon
                                        v-if="item.passStatus === 'REJECTED'"
                                        :style="{ 'background-image': 'url(' + require('@/assets/circle.svg') + ')' }"
                                        class="iconbackground display-1 warning--text icons8-high-importance"
                                    ></v-icon>
                                    <v-icon
                                        v-if="item.passStatus === 'PENDING'"
                                        :style="{ 'background-image': 'url(' + require('@/assets/circle.svg') + ')' }"
                                        class="iconbackground display-1 grey--text icons8-circle"
                                    ></v-icon>
                                    <v-icon
                                        v-if="item.passStatus === 'SUSPENDED'"
                                        :style="{ 'background-image': 'url(' + require('@/assets/circle.svg') + ')' }"
                                        class="iconbackground display-1 error--text icons8-private"
                                    ></v-icon>
                                </v-col>
                                <v-col cols="7" class="d-flex flex-column">
                                    <div style="margin: 0px !important; line-height: 20px !important;" class="noselect">
                                        <span class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.passName }}</span>
                                    </div>
                                    <div style="" class="font-weight-bold caption grey--text text--darken-1 noselect">{{ item.passType }}</div>
                                    <div class="caption noselect">{{ item.passDate }}</div>
                                </v-col>
                                <v-col cols="3" class="text-right"
                                    ><v-btn @click="openItem(item.id, 'View', false)" depressed class="black--text white"
                                        >Open<v-icon>mdi-chevron-right</v-icon></v-btn
                                    ></v-col
                                >
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * COPYRIGHT -->
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-0 copyright">
                    <appcopyright />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex' // Map Actions / Getters
export default {
    // * DATA
    data: () => ({
        collection: 'swappLogs',
        collectionTitle: 'Swapp Logs',
        collectionItem: 'swappLog',
        collectionItemTitle: 'Swapp Log',
        langPath: 'swappLog',
        columnsDialog: false,

        search: '', // Table Search
        filter: {
            // Default Filters
            sortAsc: false,
            site: '',
            location: '',
            user: '',
            status: [],
            method: ['MANUAL', 'QRCODE', 'RFID'],

            organisation: null,
            formattedSWAPPFromDate: '',
            formattedSWAPPToDate: ''
        },

        tableData: [], // Table Data
        headers: [
            // Table Headers
            // hidden shows the initial value of the column - hidden or visible
            // { text: 'id', value: 'id', align: 'center', sortable: false, hidden: false, hide: false },
            { text: 'Status', value: 'swappStatus', align: 'center', sortable: false, hidden: false, hide: false },
            { text: 'Site', value: 'site.siteName', align: 'left', sortable: false, hidden: false, hide: false },
            { text: 'Location', value: 'location.locationName', align: 'left', sortable: false, hidden: false, hide: false },
            { text: 'User', value: 'userName', align: 'left', sortable: false, hidden: false, hide: false },
            { text: 'Type', value: 'userType', align: 'left', sortable: false, hidden: false, hide: false },
            { text: 'Function', value: 'userFunction', align: 'left', sortable: false, hidden: false, hide: false, width: '100px' },
            { text: 'Sponsor', value: 'userSponsor', align: 'left', sortable: false, hidden: false, hide: false, width: '100px' },
            { text: 'Method', value: 'swappMethod', align: 'center', sortable: false, hidden: false, hide: false },
            { text: 'Swapped at', value: 'createdDateTime', align: 'center', sortable: false, hidden: false, hide: false }
        ],

        lastVisible: 0,
        firstVisible: 0,
        unsubscribeFunctions: [], // Added for cleanup

        datatableOptions: {
            page: 1,
            itemsPerPage: 10,
            sortBy: ['createdDateTime'],
            sortDesc: [false],
            groupBy: [],
            groupDesc: [],
            mustSort: false,
            multiSort: false
        },
        sortBy: ['createdDateTime'],

        locations: [],
        sites: [],
        users: [],

        filteredHeaders: [],
        itemsFrom: 0
    }),
    // * COMPUTED
    computed: {
        // Map Getters
        ...mapGetters({
            GET_currentUser: 'GET_currentUser',
            GET_panelLayout: 'GET_panelLayout',
            GET_lookupValues: 'GET_lookupValues',
            GET_sites: 'GET_sites',
            GET_usersMA: 'GET_usersMA',
            GET_organisations: 'GET_organisations',
            GET_datePickerResult: 'datePicker_store/GET_datePickerResult', // Get Date Picker Result
            GET_help: 'GET_help'
        }),
        // EXPORT
        formatExport() {
            this.exportData = JSON.parse(JSON.stringify(this.computedTableData))
            return this.exportData
        },
        // Remove actions from Selectable Column Headers
        columnHeaders() {
            const headers = this.headers
            return headers.filter(header => {
                return header.value !== 'actions'
            })
        },
        // Computed Cols
        computedCols() {
            const leftPanel = this.GET_panelLayout.leftPanel
            let cols
            switch (true) {
                case leftPanel === 12:
                    cols = 6
                    break
                case leftPanel === 6:
                    cols = 12
                    break
                default:
                    cols = 12
            }
            if (this.$vuetify.breakpoint.smAndDown) {
                cols = 12
            }
            return cols
        },
        // LOCATIONS HISTORY HEADERS
        computedTableData() {
            const locations = this.tableData
            return locations
        }
    },
    // * WATCH
    watch: {
        GET_currentUser: {
            handler() {
                this.getTableData()
            },
            deep: true
        },
        GET_datePickerResult: {
            // Watch for a change in the Date Picker Result and Update the Project Start or End Date based on the Date Picker Result Field
            handler() {
                switch (this.GET_datePickerResult.field) {
                    case 'SWAPPFromDate':
                        this.filter.formattedSWAPPFromDate = this.MIX_formatDateTime(
                            this.$moment(this.GET_datePickerResult.value, 'x')
                                .startOf('day')
                                .format('x'),
                            'x',
                            'DD-MMM-YY'
                        )
                        break
                    case 'SWAPPToDate':
                        this.filter.formattedSWAPPToDate = this.MIX_formatDateTime(
                            this.$moment(this.GET_datePickerResult.value, 'x')
                                .endOf('day')
                                .format('x'),
                            'x',
                            'DD-MMM-YY'
                        )
                        break
                    default:
                        break
                }
            },
            deep: true
        },
        GET_panelLayout: {
            handler() {
                if (this.GET_panelLayout.rightPanel === 6) {
                    this.filteredHeaders = this.headers.filter(header => {
                        return header.hide === false && header.hidden === false
                    })
                } else {
                    this.filteredHeaders = this.headers.filter(header => {
                        return header.hidden === false
                    })
                }
            },
            deep: true
        },
        headers: {
            handler() {
                this.filteredHeaders = this.headers.filter(header => {
                    return header.hidden === false
                })
            },
            deep: true
        },
        datatableOptions: {
            handler() {
                this.itemsFrom = this.datatableOptions.page * this.datatableOptions.itemsPerPage - this.datatableOptions.itemsPerPage
                const itemsTo = this.datatableOptions.page * this.datatableOptions.itemsPerPage
            },
            deep: true
        },
        filter: {
            handler() {
                // Debounce to avoid too many calls
                clearTimeout(this.filterTimeout)
                this.filterTimeout = setTimeout(() => {
                    this.getMoreTableData()
                }, 300)
            },
            deep: true
        }
    },
    // * METHODS
    methods: {
        ...mapActions({ ACT_openItem: 'ACT_openPass' }),
        // UPDATE BREADCRUMBS
        updateBreadcrumbs() {
            const breadcrumbs = []
            breadcrumbs.push({ name: `${this.collectionTitle}`, path: `/${this.collection}` })
            this.MIX_breadcrumbs(breadcrumbs)
        },
        async exportCSV() {
            let data = []

            // Helper function to build base query with common filters
            const buildBaseQuery = collection => {
                if (this.filter.user !== '' && this.filter.user !== undefined && this.filter.user !== null) {
                    collection = collection.where('swappedUser', '==', this.filter.user.id)
                }
                if (this.filter.formattedSWAPPFromDate !== '' && this.filter.formattedSWAPPFromDate !== null) {
                    collection = collection.where('createdDateTime', '>=', this.$moment(this.filter.formattedSWAPPFromDate, 'DD-MMM-YY').format('X'))
                }
                if (this.filter.formattedSWAPPToDate !== '' && this.filter.formattedSWAPPToDate !== null) {
                    collection = collection.where(
                        'createdDateTime',
                        '<=',
                        this.$moment(this.filter.formattedSWAPPToDate, 'DD-MMM-YY')
                            .add(1, 'day')
                            .format('X')
                    )
                }
                if (this.filter.status !== '' && this.filter.status !== undefined && this.filter.status !== null && this.filter.status.length > 0) {
                    collection = collection.where('swappStatus', 'in', this.filter.status)
                }
                return collection
            }

            // Fetch data with OR logic for site filtering
            if (this.filter.site !== '' && this.filter.site !== undefined && this.filter.site !== null) {
                // Handle OR condition - fetch from both queries
                const data1 = await this.fetchDataFromQuery(
                    buildBaseQuery(this.$firebase.db.collection('swappLogs').where('site.siteId', '==', this.filter.site))
                )
                const data2 = await this.fetchDataFromQuery(
                    buildBaseQuery(this.$firebase.db.collection('swappLogs').where('site.id', '==', this.filter.site))
                )

                // Merge and deduplicate
                const allDocs = new Map()
                data1.forEach(doc => allDocs.set(doc.id, doc))
                data2.forEach(doc => allDocs.set(doc.id, doc))
                data = Array.from(allDocs.values())
            } else {
                // No site filter - single query
                data = await this.fetchDataFromQuery(buildBaseQuery(this.$firebase.db.collection('swappLogs')))
            }

            // Process data for CSV
            data = data.filter(item => !item.hasOwnProperty('delete'))

            data.forEach(item => {
                const user = this.users.find(user => user.id === item.swappedUser)
                if (user !== undefined) {
                    item.userName = user.userName
                    item.userType = user.userType
                    item.userFunction = user.function
                    if (item.userFunction && item.userFunction !== undefined && Array.isArray(item.userFunction)) {
                        item.userFunction = item.userFunction.filter(el => el != null)
                    }
                    item.userSponsor = user.host ? user.host.userName : ''
                }
            })

            // Sort by createdDateTime
            data.sort((a, b) => parseInt(a.createdDateTime) - parseInt(b.createdDateTime))

            data = data.map(item => ({
                Status: item.swappStatus === 1 ? 'IN' : 'OUT',
                Site: item.site.siteName,
                Location: item.location.locationName,
                User: item.userName,
                'User Type': item.userType,
                'User Function': item.userFunction,
                'User Sponsor': item.userSponsor,
                Method: item.swappMethod,
                'Swapped Date': this.$moment(item.createdDateTime, 'x').format('DD-MMM-YY'),
                'Swapped Time': this.$moment(item.createdDateTime, 'x').format('HH:mm')
            }))

            const csv = this.$papa.unparse(data)
            this.$papa.download(csv, 'swappLogs')
        },

        // Helper method to fetch data from a query with pagination
        async fetchDataFromQuery(collection) {
            const data = []
            let lastVisible = null
            let allDataFetched = false

            while (!allDataFetched) {
                let query = collection.orderBy('createdDateTime').limit(100)

                if (lastVisible) {
                    query = query.startAfter(lastVisible)
                }

                const snapshot = await query.get()

                if (snapshot.empty) {
                    allDataFetched = true
                    break
                }

                const documents = snapshot.docs.map(doc => {
                    const docData = doc.data()
                    docData.id = doc.id
                    return docData
                })
                data.push(...documents)

                lastVisible = snapshot.docs[snapshot.docs.length - 1]
            }

            return data
        },
        // GET NOTICES SNAPSHOT METHOD - Updated with OR query logic
        getMoreTableData() {
            // Clean up existing listeners first
            this.cleanupListeners()

            // Helper function to build base query with common filters
            const buildBaseQuery = collection => {
                if (this.filter.user !== '' && this.filter.user !== undefined && this.filter.user !== null) {
                    collection = collection.where('swappedUser', '==', this.filter.user.id)
                }
                if (this.filter.formattedSWAPPFromDate !== '' && this.filter.formattedSWAPPFromDate !== null) {
                    collection = collection.where('createdDateTime', '>=', this.$moment(this.filter.formattedSWAPPFromDate, 'DD-MMM-YY').format('X'))
                }
                if (this.filter.formattedSWAPPToDate !== '' && this.filter.formattedSWAPPToDate !== null) {
                    collection = collection.where(
                        'createdDateTime',
                        '<=',
                        this.$moment(this.filter.formattedSWAPPToDate, 'DD-MMM-YY')
                            .add(1, 'day')
                            .format('X')
                    )
                }
                if (this.filter.status !== '' && this.filter.status !== undefined && this.filter.status !== null && this.filter.status.length > 0) {
                    collection = collection.where('swappStatus', 'in', this.filter.status)
                }
                return collection
            }

            // Handle site filtering with OR logic
            if (this.filter.site !== '' && this.filter.site !== undefined && this.filter.site !== null) {
                // Create two separate queries for OR condition
                let collection1 = this.$firebase.db.collection('swappLogs')
                collection1 = buildBaseQuery(collection1)
                collection1 = collection1.where('site.siteId', '==', this.filter.site)

                let collection2 = this.$firebase.db.collection('swappLogs')
                collection2 = buildBaseQuery(collection2)
                collection2 = collection2.where('site.id', '==', this.filter.site)

                // Add ordering and limits
                collection1 = collection1.orderBy('createdDateTime').limit(50)
                collection2 = collection2.orderBy('createdDateTime').limit(50)

                // Reactive data for storing results
                const results1 = new Map()
                const results2 = new Map()

                const processResults = () => {
                    // Merge and deduplicate results
                    const allDocs = new Map()
                    results1.forEach((doc, id) => allDocs.set(id, doc))
                    results2.forEach((doc, id) => allDocs.set(id, doc))

                    // Convert to array and sort by createdDateTime
                    let mergedDocs = Array.from(allDocs.values()).sort((a, b) => {
                        return parseInt(a.createdDateTime) - parseInt(b.createdDateTime)
                    })

                    // Limit to 100 total results
                    mergedDocs = mergedDocs.slice(0, 100)

                    // Process the merged results
                    this.tableData = []
                    if (mergedDocs.length > 0) {
                        this.firstVisible = mergedDocs[0]
                        this.lastVisible = mergedDocs[mergedDocs.length - 1]
                    }

                    mergedDocs.forEach(document => {
                        if (!document.hasOwnProperty('delete')) {
                            // find user in user array and assign userType and userFunction
                            const user = this.users.find(user => user.id === document.swappedUser)
                            if (user !== undefined) {
                                this.$set(document, 'userName', user.userName)
                                this.$set(document, 'userType', user.userType)
                                this.$set(document, 'userFunction', user.function)

                                if (document.userFunction && document.userFunction !== undefined && Array.isArray(document.userFunction)) {
                                    // remove any blanks from user function
                                    document.userFunction = document.userFunction.filter(el => el != null)
                                }
                                this.$set(document, 'userSponsor', user.host ? user.host.userName : '')
                            }
                            this.tableData.push(document)
                        }
                    })
                }

                const unsubscribe1 = collection1.onSnapshot(querySnapshot => {
                    results1.clear()
                    querySnapshot.forEach(doc => {
                        const document = doc.data()
                        document.id = doc.id
                        results1.set(doc.id, document)
                    })
                    processResults()
                })

                const unsubscribe2 = collection2.onSnapshot(querySnapshot => {
                    results2.clear()
                    querySnapshot.forEach(doc => {
                        const document = doc.data()
                        document.id = doc.id
                        results2.set(doc.id, document)
                    })
                    processResults()
                })

                // Store unsubscribe functions for cleanup
                this.unsubscribeFunctions = [unsubscribe1, unsubscribe2]
            } else {
                // No site filter - use single query
                let collection = this.$firebase.db.collection('swappLogs')
                collection = buildBaseQuery(collection)

                const unsubscribe = collection
                    .orderBy('createdDateTime')
                    .limit(100)
                    .onSnapshot(querySnapshot => {
                        this.tableData = []
                        if (querySnapshot.docs.length > 0) {
                            this.firstVisible = querySnapshot.docs[0]
                            const lastVis = querySnapshot.docs[querySnapshot.docs.length - 1]
                            if (lastVis !== undefined) {
                                this.lastVisible = lastVis
                            }
                        }
                        querySnapshot.forEach(doc => {
                            const document = doc.data()
                            document.id = doc.id
                            if (!document.hasOwnProperty('delete')) {
                                // find user in user array and assign userType and userFunction
                                const user = this.users.find(user => user.id === document.swappedUser)
                                if (user !== undefined) {
                                    this.$set(document, 'userName', user.userName)
                                    this.$set(document, 'userType', user.userType)
                                    this.$set(document, 'userFunction', user.function)

                                    if (document.userFunction && document.userFunction !== undefined && Array.isArray(document.userFunction)) {
                                        // remove any blanks from user function
                                        document.userFunction = document.userFunction.filter(el => el != null)
                                    }
                                    this.$set(document, 'userSponsor', user.host ? user.host.userName : '')
                                }
                                this.tableData.push(document)
                            }
                        })
                    })

                // Store single unsubscribe function
                this.unsubscribeFunctions = [unsubscribe]
            }
        },

        // Cleanup method to unsubscribe from listeners
        cleanupListeners() {
            if (this.unsubscribeFunctions && Array.isArray(this.unsubscribeFunctions)) {
                this.unsubscribeFunctions.forEach(unsubscribe => {
                    if (typeof unsubscribe === 'function') {
                        unsubscribe()
                    }
                })
                this.unsubscribeFunctions = []
            }
        },

        goBackTableData: async function() {
            this.$firebase.db
                .collection('swappLogs')
                .orderBy('createdDateTime')
                .endBefore(this.firstVisible)
                .limit(10)
                .onSnapshot(function(querySnapshot) {
                    this.tableData = []
                    this.firstVisible = querySnapshot.docs[0]
                    this.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
                    querySnapshot.forEach(function(doc) {
                        const document = doc.data()
                        document.id = doc.id
                        if (!document.hasOwnProperty('delete')) {
                            this.tableData.push(document)
                        }
                    })
                })
        },

        getTableDataCount: async function() {
            const collectionRef = this.$firebase.db.collection('swappLogs')
            const snapshot = await collectionRef.count().get()
        },

        getUsers: async function() {
            const userData = []
            const t = this
            t.$firebase.db
                .collection('users')
                .orderBy('userName')
                .onSnapshot(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        const document = doc.data()
                        document.id = doc.id
                        if (!document.hasOwnProperty('delete')) {
                            document.userName = t.toTitleCase(document.userName)
                            userData.push(document)
                        }
                    })
                    userData.sort((a, b) => (a.userName > b.userName ? 1 : -1))
                })
            return userData
        },

        toTitleCase: function(str) {
            return str.replace(/\w\S*/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
            })
        },

        customFilter(queryText, itemText) {
            const searchText = queryText.toString().toLowerCase()
            const itemName = itemText.toString().toLowerCase()
            return itemName.includes(searchText)
        }
    },

    // * LIFECYCLE HOOKS
    async mounted() {
        this.filter.formattedSWAPPFromDate = this.$moment().format('DD-MMM-YY')
        this.MIX_setPanelLayout(12, 0, false, '') // Hide Right Panel
        this.updateBreadcrumbs() // Update Breadcrumbs in Title

        this.sites = this.GET_sites // STORE SITES IN LOCAL ARRAY
        this.users = await this.getUsers()
        this.getMoreTableData() // Get Table Data
    },

    beforeDestroy() {
        // Clean up listeners when component is destroyed
        this.cleanupListeners()
    }
}
</script>
